import React, { useEffect, useState } from "react";
import { api, brl, formatDate } from "../../lib/api";
import { X, Printer, Share2, Zap } from "lucide-react";

const PURPLE = "#2B1E4A";
const GOLD = "#F5B400";

export default function EletrosReceipt({ saleId, onClose }) {
  const [r, setR] = useState(null);
  useEffect(() => { api.get(`/eletros/sales/${saleId}/receipt`).then((res) => setR(res.data)).catch(() => onClose()); }, [saleId, onClose]);

  const shareWhatsApp = () => {
    if (!r) return;
    const parc = r.payment_method === "cash" ? "A vista" : `${r.installments_count}x`;
    const lines = [
      "*Compra Eletros*",
      `Cliente: ${r.client_name}`,
      `Pedido: ${r.number}`,
      ...r.items.map((it) => `• ${it.qty}x ${it.name} — ${brl(it.line_total)}`),
      `*Total: ${brl(r.total)}*`,
      `Pagamento: ${parc}`,
      `Revendedora: ${r.reseller_name}`,
    ];
    window.open(`https://wa.me/?text=${encodeURIComponent(lines.join("\n"))}`, "_blank");
  };

  return (
    <div className="fixed inset-0 z-[80] grid place-items-center bg-black/60 p-4" onClick={onClose}>
      <div className="max-h-[92vh] w-full max-w-sm overflow-y-auto rounded-3xl bg-white shadow-pop" onClick={(e) => e.stopPropagation()} data-testid="eletros-receipt-modal">
        {!r ? <div className="p-10 text-center text-sm text-[#9A8A98]">Carregando...</div> : (
          <>
            <div id="eletros-receipt-print" className="font-display">
              <div className="rounded-t-3xl px-6 py-6 text-center text-white" style={{ background: `linear-gradient(135deg, ${PURPLE}, #5B2CA0)` }}>
                <div className="mx-auto mb-2 grid h-12 w-12 place-items-center rounded-xl" style={{ background: GOLD }}><Zap size={24} className="text-[#2B1E4A]" /></div>
                <div className="text-[11px] font-bold uppercase tracking-[0.25em]" style={{ color: GOLD }}>Eletros</div>
                <div className="text-lg font-bold">Comprovante de compra</div>
                <div className="text-[12px] text-white/70">Pedido {r.number} · {formatDate(r.date)}</div>
              </div>
              <div className="space-y-4 px-6 py-5 text-brand-dark">
                <div className="flex justify-between text-[13px]">
                  <div><div className="text-[10px] uppercase tracking-widest text-[#9A8A98]">Cliente</div><div className="font-semibold">{r.client_name}</div></div>
                  <div className="text-right"><div className="text-[10px] uppercase tracking-widest text-[#9A8A98]">Revendedora</div><div className="font-semibold">{r.reseller_name}</div></div>
                </div>
                <div className="rounded-2xl border border-border p-3">
                  {r.items.map((it, i) => (
                    <div key={i} className="flex justify-between border-b border-border/50 py-1.5 text-[13px] last:border-0">
                      <span className="min-w-0 truncate">{it.qty}x {it.name}{it.brand ? ` (${it.brand})` : ""}</span>
                      <span className="ml-2 shrink-0 font-medium">{brl(it.line_total)}</span>
                    </div>
                  ))}
                  <div className="mt-2 flex justify-between border-t-2 border-[#2B1E4A]/10 pt-2">
                    <span className="font-bold">Total</span>
                    <span className="font-display text-lg font-bold" style={{ color: PURPLE }}>{brl(r.total)}</span>
                  </div>
                </div>
                <div className="rounded-2xl bg-[#F1ECF7] p-3 text-[13px]">
                  <div className="flex justify-between"><span className="text-[#6B5A69]">Pagamento</span><span className="font-semibold">{r.payment_method === "cash" ? "A vista" : `Parcelado em ${r.installments_count}x`}</span></div>
                  {r.installments?.length > 0 && r.payment_method !== "cash" && (
                    <div className="mt-2 space-y-1">
                      {r.installments.map((i) => (
                        <div key={i.number} className="flex justify-between text-[12px]">
                          <span className="text-[#6B5A69]">Parcela {i.number} · venc. {formatDate(i.due_date)}</span>
                          <span className="font-medium">{brl(i.amount)}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div className="text-center text-[11px] text-[#9A8A98]">Obrigada pela preferencia! · Eletros</div>
              </div>
            </div>

            <div className="no-print flex gap-2 border-t border-border p-4">
              <button onClick={() => window.print()} data-testid="receipt-print-btn" className="flex flex-1 items-center justify-center gap-1 rounded-xl border border-border py-3 text-sm font-semibold text-[#5B2CA0]"><Printer size={15} /> Imprimir / PDF</button>
              <button onClick={shareWhatsApp} data-testid="receipt-share-btn" className="flex flex-1 items-center justify-center gap-1 rounded-xl py-3 text-sm font-semibold text-white" style={{ background: "#25D366" }}><Share2 size={15} /> WhatsApp</button>
              <button onClick={onClose} className="rounded-xl border border-border px-3 py-3 text-[#6B5A69]"><X size={16} /></button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
